import React, { useEffect, useState } from 'react'
import { Pagination, Table } from 'react-bootstrap'
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle'
import DashboardContent from '../../dashboardWrapper/DashboardContent'
import Wrapper from '../../dashboardWrapper/Wrapper'
import PublishModal from './Modals/PublishModal'
import BlockModal from './Modals/BlockModal'
import UnPublishModal from './Modals/UnPublishModal'
import UnBlockModal from './Modals/UnBlockModal'
import DeatilsModal from './Modals/DeatilsModal'
import { useDispatch, useSelector } from 'react-redux'
import MainLoading from '../../../utils/MainLoading'
import { fetchAllUserProfiles, fetchAllUserProfilesPagination } from '../../../redux/action/userProfile/users-profile'
import { useTranslation } from 'react-i18next'
import SaloonModal from './Modals/SaloonModal'

const AdminCompaniesManagement = () => {
    const [show, setShow] = useState(true);
    const [forceUpdate, setForceUpdate] = useState(0)
    const dispatch = useDispatch()
    const companies = useSelector(state => state.all_users_profile)
    const {t} = useTranslation();

    const [modal, setModal] = useState({
        delete: false,
        block: false,
        unblock: false,
        publish: false,
        unpublish: false,
        details: false,
        chooseSaloon: false,
        id: ''
    })

    const handleClick = () => { setShow(false) }

    const handleBlock = (id) => { {
        setModal({  block: true, id: id })
        setShow(true)
    }}

    const handleUnBlock = (id) => { {
        setModal({ unblock: true, id: id })
        setShow(true)
    }}

    const handlepublish = (id) => { {
        setModal({  publish: true, id: id }) 
        setShow(true)
    }}

    const handleUnpublish = (id) => { {
        setModal({  unpublish: true, id: id }) 
        setShow(true)
    }}

    const handleDetails = (id) => {
        setModal({ details: true, id: id })
        setShow(true)
    }

    const handleSaloonChoose = (id) => {
        setModal({ chooseSaloon: true, id: id })
        setShow(true)
    }

    const update = () => {
        setForceUpdate(1)
        setShow(false)
        setTimeout(() => {
            dispatch(fetchAllUserProfiles())
        }, 1000)
    }

    useEffect(() => {
        if(!companies.all_users.data) {
            dispatch(fetchAllUserProfiles())
        }
    }, [])

    const handlePaginate = (e) => {
        e.preventDefault()
        dispatch(fetchAllUserProfilesPagination(e.target.href))
    }


    return (
        <Wrapper>
            <DashboardContent>
                <DashboardMainTitle> {t("dashboard_nav_companies_management")} </DashboardMainTitle>
                {companies.loading ? 
                    <MainLoading />
                    :
                    companies.all_users.data &&
                        companies.all_users.data.length ?
                            <div className='halls_table'>
                                <Table responsive bordered>
                                    <thead>
                                    <tr>
                                        <th className='text-center col-3'>{t("company name")}</th>
                                        <th className='text-center col-3'>{t("CEO name")}</th>
                                        <th className='text-center col-2'>{t("hall")}</th>
                                        <th className='text-center col-2'>{t("situation")}</th>
                                        <th className='text-center col-2'>{t("publish")}</th>
                                        <th className='text-center col-2'>{t("details")}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {companies.all_users &&
                                        companies.all_users.data ?
                                            companies.all_users.data.map(item => (
                                                <tr key={item.id}>
                                                    <td>{item.title}</td>
                                                    <td>{item.manager_name}</td>
                                                    <td className='text-center'>
                                                    {item.saloon &&
                                                        item.saloon.name ? 
                                                            <button className='btn btn-success btn-sm px-3' onClick={id => handleSaloonChoose(item.id)}>{item.saloon.name}</button>
                                                        : 
                                                            <button className='btn btn-primary btn-sm px-3' onClick={id => handleSaloonChoose(item.id)}>{t("choose saloon")}</button>
                                                    }
                                                    </td>
                                                    <td className='text-center'>
                                                        {item.is_block ?
                                                            <button className='btn btn-success btn-sm' onClick={id => handleUnBlock(item.id)}>{t("unblock company")}</button>
                                                        :
                                                            <button className='btn btn-danger btn-sm' onClick={id => handleBlock(item.id)}>{t("block company")}</button>
                                                        }
                                                    </td>                                     
                                                    <td className='text-center'>
                                                        {item.saloon && item.saloon.name ?
                                                            item.is_published ?
                                                                <button className='btn btn-danger btn-sm' onClick={id => handleUnpublish(item.id)}>{t("Hide company")}</button>
                                                            :
                                                                <button className='btn btn-success btn-sm' onClick={id => handlepublish(item.id)}>{t("show company")}</button>
                                                        
                                                            :
                                                                t("no saloon")
                                                        }
                                                    </td>
                                                    <td className='text-center'><button className='btn btn-warning btn-sm' onClick={id => handleDetails(item.id)}>{t("details")}</button></td>
                                                </tr>
                                            ))
                                        : <tr><td>{t("No company has been created yet")}</td></tr>
                                        }
                                    </tbody>
                                </Table>
                                <div className='pagination_container mt-3'>
                                    <Pagination>
                                        {companies.all_users.links ? companies.all_users.links.map(link => (
                                            <Pagination.Item href={link.url} disabled={link.url ? false : true} active={link.active} key={link.label} onClick={id => {handlePaginate(id)}}>
                                                {link.label.replace('&laquo;', '').replace('&raquo;', '')}
                                            </Pagination.Item>
                                        )) : ''}
                                    </Pagination>
                                </div>
                            </div>
                        :
                            <h6 className='text-center'>{t("No company found")}</h6>
                }
            </DashboardContent>
            {modal.block && <BlockModal id={modal.id} show={show} handleClick={handleClick} update={update} />}
            {modal.unblock && <UnBlockModal id={modal.id} show={show} handleClick={handleClick} update={update} />}
            {modal.publish && <PublishModal id={modal.id} show={show} handleClick={handleClick} update={update} />}
            {modal.unpublish && <UnPublishModal id={modal.id} show={show} handleClick={handleClick} update={update} />}
            {modal.details && <DeatilsModal id={modal.id} show={show} handleClick={handleClick} update={update} />}
            {modal.chooseSaloon && <SaloonModal id={modal.id} show={show} handleClick={handleClick} update={update} />}

        </Wrapper>
    )
}

export default AdminCompaniesManagement
